export default {
  path: '/ai-listing-helper',
  name: 'ai-listing-helper',
  meta: {
    title: 'AI Listing Helper — eRank',
    noScroll: true,
    requiresAuth: true,
    metaTags: [
      {
        name: 'description',
        content: 'Quickly generate titles, tags, and descriptions for your Etsy listings with eRank’s AI-powered Listing Helper.',
      },
    ],
  },
  component: () => import('@/modules/listing-helper/pages/Entry.vue'),
};
